import { MetaMapper } from 'mapper/MetaMapper';

import { projectLayoutMapper } from './projectLayoutMapper';

export const metaMapper = new MetaMapper(projectLayoutMapper);
